export default __webpack_public_path__ + "static/media/InsideEars_08.91988f75.png";